module.exports = __webpack_public_path__ + "static/water-place-winter-ccf646d807465827b2e8b63374348479.jpg";